<template>
    <div>
        <el-menu
        :default-active="path"
        class="el-menu-vertical-demo"
        router
        background-color="#fff"
        text-color="#333"
        active-text-color="#0077FF"
        @select="handleOpen"
        >
            <div class="topMsg">
                <div class="leftimg">
                    <img v-if="avatar" :src="avatar" :onerror="defaultAvatarImgae" alt />
                    <img v-else src="../../assets/imgs/hello.png" alt />
                </div>
                <div class="righttext">
                    <span style="white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width:100px;">{{nickname}}</span>
                    <span style="word-wrap:break-word;word-break:break-all;overflow: hidden;">{{role_name}}</span>
                </div>
            </div>
            <div v-for="(item,index) in routeList" :key="index">
                <el-submenu v-show="item.isActive" :index="index+''">
                    <template slot="title">
                        <img class="asideimg" :src="index_active==index?item.icon_active:item.icon" />{{item.name}}
                    </template>
                    <div v-for="(el,i) in item.children"  :key="i">
                        <el-menu-item v-show="el.isActive" :index="el.path">{{el.name}}</el-menu-item>
                    </div>
                </el-submenu>
            </div>
        </el-menu>
    </div>
</template>

<script>
export default {
     data(){
        return {
            path:this.$route.path,
            defaultAvatarImgae:'this.src="' + require("../../assets/imgs/hello.png") + '"',
            avatar:'',
            nickname:'',
            role_name:'',
            routeList:[ {
                name: '我的资料',
                icon: require('../../assets/imgs/myicon.png'),
                icon_active: require('../../assets/imgs/myicon_active.png'),
                isActive:true,
                children:[ {
                    path: '/mymsg',
                    name: '个人中心',
                    isActive:true,
                } ]
            },{
                name:'数据中心',
                icon:require('../../assets/imgs/homepage.png'),
                icon_active: require('../../assets/imgs/homepage_active.png'),
                isActive:true,
                children:[ {
                    path:'/basic',
                    name:'基础数据',
                    isActive:true,
                } ]
            }, {
                name:'职位管理',
                icon:require('../../assets/imgs/positionicon.png'),
                icon_active: require('../../assets/imgs/positionicon_active.png'),
                isActive:true,
                children:[ {
                    path:'/positionlist',
                    isActive:true,
                    name:'职位列表'
                } ]
            }, {
                name:'简历管理',
                icon:require('../../assets/imgs/resumeicon.png'),
                icon_active: require('../../assets/imgs/resumeicon_active.png'),
                isActive:true,
                children:[
                    {
                        path:'/resumelist',
                        isActive:false,
                        name:'简历列表'
                    },
                    {
                        path:'/personnelsearch',
                        isActive:false,
                        name:'人才搜索'
                    }
                ]
            },
            {
                name:'我的收藏',
                icon:require('../../assets/imgs/collection.png'),
                icon_active: require('../../assets/imgs/collection_active.png'),
                isActive:true,
                children:[ {
                    path:'/collection',
                    name:'收藏列表',
                    isActive:true,
                } ]
            },
            {
                name:'账号与权限',
                icon:require('../../assets/imgs/roleicon.png'),
                icon_active: require('../../assets/imgs/roleicon_active.png'),
                isActive:true,
                children:[ {
                    path:'/roleJurisdiction',
                    isActive:true,
                    name:'角色权限'
                }, {
                    path:'/accountmanagement',
                    isActive:true,
                    name:'账号管理'
                } ]
            }],
            index_active:0
        }
    },
    methods:{
        handleOpen(key, keyPath) {
            var el = document.getElementsByClassName('el-submenu__title');
            for(var i = 0; i<el.length;i++){
                el[i].classList.remove("el-submenu__title_active");
            }
            el[keyPath[0]].classList.add("el-submenu__title_active");
            this.index_active = keyPath[0];
        },
        foremtMenu(datas){
            var that = this;
            if(datas&&datas.length){
                for(var i = 0; i < datas.length;i++){
                    that.routeList[i].isActive = datas[i].view_code===0?false:true;
                    for(var j = 0; j < datas[i].menu.length;j++){
                        that.routeList[i].children[j].isActive = datas[i].menu[j].isActive;
                    }
                }
            }else{
                that.routeList = that.routeList.slice(0,1);
            }
        },
        account(path){
            var that = this;
            var account = JSON.parse(localStorage.getItem('account'))||{};
            that.foremtMenu(account.menu_detail||[]);
            that.nickname = account.nickname;
            that.role_name = account.role_name;
            that.avatar = account.avatar;
            path?that.path = path:null;
        }
    },
    mounted(){
        var that = this;
        var el = document.getElementsByClassName('el-submenu__title');
        var activePath = this.$router.history.current.path;
        for(var i = 0; i < this.routeList.length; i++){
            for(var j = 0; j <this.routeList[i].children.length;j++) {
                if(this.routeList[i].children[j].path===activePath){
                     el[i].classList.add("el-submenu__title_active");
                     this.index_active = i;
                }
            }
        }
    }
}
</script>
<style>
.asideimg {
    width: 15px;
    height: 15px;
    margin: 0 7px 0 8px;
}
.el-menu {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 5px;
}
.el-submenu{
    margin: 6px 9px!important;
}
.el-submenu__title{
    height: 36px!important;
    display: flex;
    align-items: center;
    padding-left: 0!important;
    border-left: 3px solid #fff!important;
    border-radius:3px 0px 0px 3px!important;
    font-weight: 600!important;
}
.el-submenu .el-menu-item {
    min-width: auto!important;
    height: 36px!important;
    line-height: 36px!important;
    padding-left: 35px!important;
}
.el-menu-item:hover {
    background:none!important;
}
.el-menu-item:hover {
    color:rgb(0, 119, 255)!important;
}
.el-submenu:hover .el-submenu__title{
    background: #f2f9ff !important;
    border-left: 3px solid #0077FF!important;
}
.el-submenu__title_active{
    background: #f2f9ff !important;
    border-left: 3px solid #0077FF!important;
}
/* .el-submenu__title:hover {
    background: #f2f9ff !important;
    border-left: 3px solid #0077FF;
} */
.el-menu-item .is-active {
    background: #ffffff !important;
}
.el-submenu__title .is-active {
    background: #ffffff !important;
}
.el-icon-arrow-up:before{
    content: '\e78f'!important;
    color: #CCCCCC!important;
}
.el-icon-arrow-down:before {
    content: '\e790'!important;
    color: #CCCCCC!important;
    /* width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #CCCCCC;
    font-size: 0;
    line-height: 0; */
}
</style>
<style scoped>
/*  */
.topMsg {
  width: 90%;
  min-height: 90px;
  margin: 0 auto 20px auto;
  border-bottom: 1px solid #EDEDED;
  display: flex;
  align-items: center;
}
.topMsg img {
  display: inline-block;
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.righttext {
    margin: 10px;
}
.righttext span {
  display: block;
}
.righttext span:first-child {
  font-size: 15px;
  color: rgba(51, 51, 51, 1);
}
.righttext span:last-child {
  font-size: 12px;
  color: rgba(170, 170, 170, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/public/Nav.vue